{
  "version": 1,
  "asset_id": "b0a42e02-7594-4e86-925d-f1670b45889d",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/b0a42e02-7594-4e86-925d-f1670b45889d/loc-houston-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/b0a42e02-7594-4e86-925d-f1670b45889d/loc-houston-1280.webp",
  "original_filename": "loc-houston-1280.webp",
  "size": 93818,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:27Z"
}
